import { useState } from "react";
import { useAppSelector } from "store";
import { ResizablePanels } from "@sandbox/resizable-panels";
import { Code } from "./Code";
import styles from "./Editor.module.css";
import { EditorHeader, EditorHeaderProps } from "./EditorHeader";
import { FileExplorer } from "./Explorer";
import { SaveController } from "./SaveController/SaveController";
import { EditorAlerts } from "./EditorAlerts";

interface EditorProps extends EditorHeaderProps {
}

export const Editor = (props: EditorProps) => {
  const layout = useAppSelector((state) => state.settings.layout);

  const fileExplorerWidth = layout.filePanelSize ?? 25;
  const [fileExplorerVisible, setFileExplorerVisible] = useState(layout.filePanel !== "closed");

  if (layout.filePanel === "hidden") {
    return (
      <SaveController>
        <div className={styles.codeEditorPanel}>
          <EditorHeader {...props} />
          <Code />
        </div>
      </SaveController>
    )
  }

  return (
    <EditorAlerts>
      <SaveController>
        <ResizablePanels
          snap={true}
          hideSashOnSnap={true}
          defaultSizes={[fileExplorerWidth, 100 - fileExplorerWidth]}
          firstPanel={{ preferredSize: `${fileExplorerWidth}%`, visible: fileExplorerVisible, onVisibilityChange: setFileExplorerVisible }}
          secondPanel={{ preferredSize: `${100 - fileExplorerWidth}%`, visible: true, minSize: 200, snap: false }}
        >
          <FileExplorer onCollapse={() => setFileExplorerVisible(false)} />
          <div className={styles.codeEditorPanel} data-testid="atp-editor-panel">
            <EditorHeader  {...props} onShowFileExplorer={() => setFileExplorerVisible(true)} fileExplorerExpanded={!fileExplorerVisible} />
            <Code />
          </div>
        </ResizablePanels>
      </SaveController>
    </EditorAlerts>
  )
};
